export default "__VITE_ASSET__OPPCTzoM__"